<template>
  <div>
    <wish-list />
  </div>
</template>

<script>
import WishList from '@/components/WishList.vue';
export default {
  name: "WishlistPage",
  components: { WishList },
};
</script>

<style scoped>
</style>

